import axios from "axios";
import { getMaterialsFromStorage } from "./wasteFlowUtils";

const isHouseholdSortingMaterial = (referenceName) =>
  String(referenceName || "").startsWith("hw_");

export const matchesSortingStream = (item, streamType) => {
  const hw = isHouseholdSortingMaterial(item?.referenceName);
  return streamType === "hw" ? hw : !hw;
};

const normalizeRef = (value) => String(value || "").toLowerCase();

/**
 * Charge le catalogue matières (même source que App.js) et le met en cache localStorage.
 */
export async function fetchMaterialsCatalog(API, token) {
  if (!API || !token) return getMaterialsFromStorage();
  try {
    const response = await axios.get(`${API}material`, {
      headers: { authorization: `Bearer ${token}` },
    });
    if (response.status >= 200 && response.status < 400) {
      const list = response.data?.materialList;
      if (Array.isArray(list)) {
        localStorage.setItem("materialsDescription", JSON.stringify(list));
        return list;
      }
    }
  } catch {
    // fallback cache
  }
  return getMaterialsFromStorage();
}

/**
 * Construit la liste des matières tri (erreurs) avec isChecked = non autorisé.
 */
export function buildSortingItemsFromAuthorized(authorizedMaterial) {
  const raw = getMaterialsFromStorage();
  const allowed = new Set(
    (authorizedMaterial || [])
      .map((m) => normalizeRef(m?.value ?? m?.referenceName))
      .filter(Boolean),
  );

  return raw
    .filter((m) => m?.isActiveSortingError === true)
    .map((m) => {
      const ref = m?.referenceName ?? "";
      return {
        ...m,
        isChecked: !allowed.has(normalizeRef(ref)),
      };
    });
}

/**
 * Reconstruit les items après chargement du catalogue en conservant les choix utilisateur.
 */
export function mergeSortingItemsWithCatalog(
  authorizedMaterial,
  previousItems = [],
) {
  const fresh = buildSortingItemsFromAuthorized(authorizedMaterial);
  if (!previousItems?.length) return fresh;

  const prevByRef = new Map(
    previousItems.map((item) => [item.referenceName, item.isChecked]),
  );

  return fresh.map((item) => ({
    ...item,
    isChecked: prevByRef.has(item.referenceName)
      ? prevByRef.get(item.referenceName)
      : item.isChecked,
  }));
}

export function applySortingItemsToFormData(formData, items, t) {
  return {
    ...formData,
    authorizedMaterial: items
      .filter((item) => item.isChecked === false)
      .map((item) => ({
        name:
          typeof t === "function" ? t(item.referenceName) : item.referenceName,
        value: item.referenceName,
        parentCategory: item.parentCategory,
      })),
  };
}

export function countSortingMaterialsByStream(items, streamType) {
  const list = Array.isArray(items) ? items : [];
  return list.filter((m) => {
    if (m?.isActiveSortingError !== true) return false;
    const hw = isHouseholdSortingMaterial(m.referenceName);
    return streamType === "hw" ? hw : !hw;
  }).length;
}

/** Catalogue chargé et au moins une matière du flux (pro ou ménager) active pour le tri. */
export function hasActiveSortingMaterialsForStream(
  items,
  streamType,
  catalogReady,
) {
  if (!catalogReady) return false;
  return countSortingMaterialsByStream(items, streamType) > 0;
}
